import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import cn from 'classnames';
import { getFAQData } from './faqData';
import { ChevronDown } from 'lucide-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { AnimatedGradientBorder, GlowCard } from 'screens/Landing/components/shared';
import { shadowAndBorderClass } from 'screens/Dashboard/utils/classes';

const Faqpage = ({ isDashboard = false }: { isDashboard?: boolean }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useTranslation();
  const FAQData = getFAQData(t);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return (
    <div
      id="faq-section"
      className={clsx(
        'bg-[transparent]relative z-[1]',
        !isDashboard && 'max-w-[1296px] max-lg:max-w-full mx-auto'
      )}
    >
      <div className="flex flex-col w-full gap-[8px] max-lg:gap-[12px]">
        {FAQData.map(({ title, text }, i) => {
          const isOpen = openIndex === i;

          const itemContent = (className?: string) => (
            <>
              <button
                onClick={() => toggle(i)}
                className="w-full cursor-pointer text-left flex items-center
              justify-between  transition-all duration-300 ease-in-out text-white gap-[10px] max-lg:gap-[10px]"
              >
                <span className="text-20 max-w-[90%] max-lg:text-16m font-luxora-medium leading-[110%]">
                  {title}
                </span>
                <div className="bg-[#2a2a2a] max-lg:rounded-[12px] rounded-[17px] w-[44px] h-[44px] flex items-center justify-center shrink-0 text-white/60">
                  <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.25, ease: 'easeInOut' }}
                  >
                    <ChevronDown size={20} />
                  </motion.div>
                </div>
              </button>

              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                      open: { height: 'auto', opacity: 1 },
                      collapsed: { height: 0, opacity: 0 },
                    }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    className="overflow-hidden flex w-full"
                  >
                    <div
                      className={clsx(
                        'mt-[8px] max-lg:mt-[12px] flex flex-col gap-[16px] w-full max-lg:gap-[12px] text-16 pr-[72px] max-lg:pr-[51px] text-left text-white/60 max-lg:text-14m leading-[110%] font-luxora-book box-border',
                        isDashboard && 'lg:max-w-[749px]'
                      )}
                    >
                      {text.map((textItem, i) => {
                        return (
                          <div className="flex flex-row h-fit w-full gap-[16px] max-lg:gap-[8px]">
                            <div
                              className={clsx(
                                'w-[4px] max-lg:w-[4px] flex rounded-full shrink-0',
                                i % 2 === 0 ? 'bg-[#CFB2FF]' : 'bg-[#FFA686]'
                              )}
                            />
                            <span className="w-full break-words">
                              {textItem}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </>
          );

          if (isDashboard) {
            return (
              <div
                key={i}
                className={clsx(
                  'bg-[#161616] pl-[24px] max-lg:pl-[24px] pr-[17px] max-lg:pr-[16px] !py-[13px] max-lg:!py-[12px] rounded-[16px] max-lg:rounded-[16px] before:!rounded-[16px] max-lg:before:!rounded-[16px]',
                  shadowAndBorderClass
                )}
              >
                {itemContent()}
              </div>
            );
          }

          return (
            <div
              key={i}
              className="bg-white/[0.04] border border-white/[0.07] pl-[24px] pr-[17px] py-[17px] max-lg:py-[12px] rounded-2xl"
            >
              {itemContent()}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Faqpage;
